import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import ElementUI from 'element-ui';
import ElementLocale from 'element-ui/lib/locale'
import qs from 'qs'
import 'element-ui/lib/theme-chalk/index.css';
import common from './common'
import md5 from 'js-md5';
import axios from 'axios';
import i18n from './lang'

ElementLocale.i18n((key, value) => i18n.t(key, value))

Vue.config.productionTip = false
Vue.use(ElementUI);


window.axios = require('axios')
window.Common = common;
window.md5 = md5;

//process.env.VUE_APP_URL
// const axiosInstance = axios.create({
//   baseURL: '/rest/api',
//   timeout: 20000,
//   headers: {
//     'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
//   }
// })s
// window.axios = axiosInstance

// axios.defaults.baseURL =  '/rest';
// axios.defaults.baseURL =  process.env.VUE_APP_URL; 
axios.defaults.timeout = 50000;
axios.defaults.headers = {
  'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8; application/json;'
};

axios.interceptors.request.use((req) => {
  if (process.env.NODE_ENV != 'development') {
    req.headers['X-Requested-With'] = 'XMLHttpRequest';
  }

  req.headers['lang'] = localStorage.getItem('lang') || 'zh';

  // 如果不是multipart/form 就使用qs序列号
  let isMultiForm = req.headers['Content-Type'].indexOf('multipart') > -1;
  let isJson = req.headers['Content-Type'].indexOf('application/json') > -1;

  if (!isJson && !isMultiForm && req.method === 'post' && typeof req.data != 'string') {
    req.data = qs.stringify(req.data);
  }
  req.metadata  = { startTime: new Date()};
  return req;
}, (error) => Promise.reject(error));

axios.interceptors.response.use(function (res) {
    //获取接口请求时间
    res.config.metadata.endTime = new Date();
    res.duration = res.config.metadata.endTime - res.config.metadata.startTime;
  return res;
}, function (error) {
  return Promise.reject(error);
});


new Vue({
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount('#app')
